var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Note_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.13341 2.33332H4.50008C3.84669 2.33332 3.51975 2.33332 3.27018 2.46048C3.05066 2.57233 2.87231 2.75068 2.76046 2.9702C2.6333 3.21977 2.6333 3.54671 2.6333 4.2001V9.8001C2.6333 10.4535 2.6333 10.78 2.76046 11.0296C2.87231 11.2491 3.05066 11.4278 3.27018 11.5396C3.5195 11.6667 3.84605 11.6667 4.49816 11.6667H10.1018C10.7539 11.6667 11.08 11.6667 11.3293 11.5396C11.5488 11.4278 11.7277 11.2489 11.8396 11.0294C11.9666 10.7801 11.9666 10.4539 11.9666 9.80179V8.16666M9.6333 2.91666L6.1333 6.41666V8.16666H7.8833L11.3833 4.66666M9.6333 2.91666L11.3833 1.16666L13.1333 2.91666L11.3833 4.66666M9.6333 2.91666L11.3833 4.66666",
    stroke: "#9333EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEdit);
export default __webpack_public_path__ + "static/media/Note_Edit.7d0cc9991486906ec81828993fc2e011.svg";
export { ForwardRef as ReactComponent };